module.exports = __webpack_public_path__ + "img/icon_help_hover.1cd78ae6.svg";